// ---------------------------------------------------------------------------
// 分发模板 — offline fallback(v6 → main 重构)
//
// v6→main 重构:relay_template / push_template 合并为 main_template,删 site_type。
// 推送模板链路整体删除。
//
// 真实数据由 mainTemplatesApi 从后端拉取。
// ---------------------------------------------------------------------------

import type { MainTemplate } from "@/api/client";

// 主模板 offline fallback(仅 mainTemplatesApi 不可用时使用)。
// 故意为空数组 —— 默认模板由 db.SeedDefaultMainTemplate 落库,
// 这里再硬编码会和真实源分叉。
export const MAIN_OFFLINE_FALLBACK: MainTemplate[] = [];
